import styled from 'styled-components';
import theme from '../../theme';

const StyledYscTransactionLimits = styled.div`
  padding: 0px 3rem;
  .custom-slider{
    margin-top: 5px !important;
    .ant-slider-track{
      background-color: ${theme.primaryColor} !important;
    }
    .ant-slider-step{
      .ant-slider-dot, &.ant-slider-dot-active{
        border-color: ${theme.primaryColor} !important;
      }
    }
    .ant-slider-handle{
      background-color: ${theme.primaryColor} !important;
      border: ${theme.primaryColor} !important;
    }
  }
  .show-slider-values{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: 3px;
    span{
      color: ${theme.lightGray};
    }
  }
  .custom-switch{
    &.ant-switch-checked{
      background-color: ${theme.btnGreen} !important;
    }
  }
`;

export {
  StyledYscTransactionLimits,
};



// WEBPACK FOOTER //
// client/containers/YscTransactionLimits/StyledYscTransactionLimits.js